module.exports = __webpack_public_path__ + "img/instagram_icon.8f39bf2a.svg";